<div class="chat-room-details-sidebar" *ngIf="chatRoom">
    <!-- Group Profile Section -->
    <div class="card profile-card">
        <div class="card-body p-3 pb-0">
            <div class="profile-info">
                <div class="profile-avatar">
                    @if (chatRoom.image?.thumbnail_url) {
                        <img [src]="chatRoom.image.thumbnail_url" [alt]="chatRoom.name" class="avatar">
                    } @else {
                        <div class="avatar-circle">
                            <span class="avatar-initials">{{ getInitials() }}</span>
                        </div>
                    }
                </div>
                
                <h4 class="profile-name">
                    {{ chatRoom.custom_name || chatRoom.name }}
                </h4>
                
                <div class="profile-members-count">
                    {{ chatRoom.member_count ?? 0 }} member{{ (chatRoom.member_count ?? 0) == 1 ? '' : 's' }}
                </div>
                
                <div class="profile-type-badge mt-2" [class.system]="chatRoom.type === 'system'" [class.custom]="chatRoom.type === 'custom'">
                    {{ chatRoom.type === 'system' ? 'System Group' : 'Custom Group' }}
                </div>
            </div>
        </div>
    </div>

    <!-- Basic Details Section -->
    <div class="card details-card">
        <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="mb-0 fw-bold">Basic details</h5>
            @if (chatRoom.type === 'custom' && (!isCoach || chatRoom.is_owner)) {
                <button class="btn-icon" type="button" title="Edit" (click)="onEditCustomGroupChat()">
                    <img src="assets/common/ic_edit_m_size.svg" alt="Edit">
                </button>
            } @else if (chatRoom.type === 'system' && !isCoach) {
                <button class="btn-icon" type="button" title="Edit" (click)="onEditSystemGroupChat()">
                    <img src="assets/common/ic_edit_m_size.svg" alt="Edit">
                </button>
            }
        </div>
        
        <div class="card-body">
            <div class="detail-item">
                <label class="detail-label">Group chat name</label>
                <div class="detail-value">{{ chatRoom.custom_name || chatRoom.name }}</div>
            </div>
            @if (chatRoom.description) {
                <div class="detail-item">
                    <label class="detail-label">Description</label>
                    <div class="detail-value chat-room-description">{{ chatRoom.description }}</div>
                </div>
            }
        </div>
    </div>

    <!-- Members Section -->
    <div class="card members-card" [class.no-border-bottom]="chatRoom.type === 'custom'">
        <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="mb-0 fw-bold">Members</h5>
            @if ((!isCoach || chatRoom.is_owner) && chatRoom.type === 'custom' && chatRoom.member_count > displayedMembers.length) {
                <a href="#" class="see-all-link" (click)="onSeeAllMembers($event)">See all</a>
            }
        </div>
        <div class="card-body">
            @if (chatRoom.member_count > displayedMembers.length) {
                <div class="member-search mt-2">
                    <img src="assets/common/ic_search_s_size.svg" alt="Search">
                    <input 
                        type="text" 
                        class="form-control" 
                        placeholder="Search members"
                        [(ngModel)]="memberSearchQuery"
                        (ngModelChange)="onMemberSearchChange()">
                </div>
            }
            
            <div class="users-list p-0">
                @if (membersSearchLoading) {
                    <div class="users-list-loading">Searching...</div>
                } @else {
                    @for (member of displayedMembers; track member.id) {
                        <div class="user-item">
                            <div class="user-avatar">
                                @if (member.avatar) {
                                    <img [src]="member.avatar" [alt]="member.name" class="avatar-image">
                                } @else {
                                    <div class="avatar-circle">
                                        <span class="avatar-initials">{{ getMemberInitials(member) }}</span>
                                    </div>
                                }
                            </div>
                            
                            <div class="user-info">
                                <div class="user-name">{{ member.name }}</div>
                                <div class="user-email">{{ member.email }}</div>
                            </div>
                            
                            <div *ngIf="member.role !== 'owner'" class="user-actions" (click)="$event.stopPropagation()">
                                <button class="btn-icon action" type="button" title="More options" (click)="onToggleMemberMenu($event, member)">
                                    <img src="assets/common/ic_three_dots.svg" alt="More options">
                                </button>
                            </div>
                        </div>
                    }
                    
                    @if (displayedMembers.length === 0) {
                        <div class="users-list-empty">No members found</div>
                    }
                }
            </div>
            
            @if ((!isCoach || chatRoom.is_owner) && chatRoom.type === 'custom') {
                <button class="btn btn-outline-secondary w-100" type="button" (click)="onAddNewMembers($event)">
                    Add new members
                </button>
            }
        </div>
    </div>

    <!-- Settings Section -->
    @if (chatRoom.type === 'system') {
        <div class="card settings-card">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h5 class="mb-0 fw-bold">Settings</h5>
                @if (!isCoach) {
                    <!--
                    @if (chatRoom.type === 'custom') {
                        <button class="btn-icon" type="button" title="Edit" (click)="onEditCustomGroupChat()">
                            <img src="assets/common/ic_edit_m_size.svg" alt="Edit">
                        </button>
                    } @else if (chatRoom.type === 'system') {
                        <button class="btn-icon" type="button" title="Edit" (click)="onEditSystemGroupChat()">
                            <img src="assets/common/ic_edit_m_size.svg" alt="Edit">
                        </button>
                    }
                    -->
                    <button class="btn-icon" type="button" title="Edit" (click)="onEditSystemGroupChat()">
                        <img src="assets/common/ic_edit_m_size.svg" alt="Edit">
                    </button>
                }
            </div>
            <div class="card-body">
                <div class="setting-item">
                    <label class="setting-label">Show in the app</label>
                    <div class="setting-value">{{ chatRoom.show_in_the_app ? 'Yes' : 'No' }}</div>
                </div>
                <!--
                <div class="setting-item">
                    <label class="setting-label">Users can send messages</label>
                    <div class="setting-value">{{ !chatRoom.is_read_only ? 'Yes' : 'No' }}</div>
                </div>
                -->
            </div>
        </div>
    }

    <!-- Member submenu (fixed so it appears on top of other content) -->
    @if (openMemberMenuId !== null && submenuPosition && getOpenMember(); as member) {
        <div class="action-submenu action-submenu-fixed"
             [style.top.px]="submenuPosition.top"
             [style.left.px]="submenuPosition.left"
             (click)="$event.stopPropagation()">
            <button type="button" class="action-submenu-item" (click)="onOpenMemberProfile(member)">
                <img src="assets/common/ic_new_tab.svg" alt="">
                <span>Open client profile</span>
            </button>
            <button type="button" class="action-submenu-item" (click)="onMessageMember(member)">
                <img src="assets/messaging/ic_new_message.svg" alt="">
                <span>Message client</span>
            </button>
        </div>
    }

    <!-- Manage members modal -->
    @if (showManageMembersModal && chatRoom) {
        <app-manage-members-modal
            [chatRoomId]="chatRoom.id"
            [memberCount]="chatRoom.member_count ?? 0"
            (close)="onCloseManageMembersModal()"
            (addNewMembers)="onAddNewMembersFromManageModal()">
        </app-manage-members-modal>
    }
</div>

